import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {ServerConfigService} from "../../services/server-config.service";
import {ErrorService} from "./error.service";

@Injectable()
export class BackendErrorInterceptor implements HttpInterceptor {

    constructor(
        private errorService: ErrorService,
        private config: ServerConfigService
    ) {
    }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && req.url.startsWith(this.config.getRestUrl())) {
                    this.errorService.showError();
                }

                return throwError(() => error);
            })
        );
    }
}
